import styles from './index.module.less';
import customConfig from 'src/config';

import {
  ButtonBase,
  Divider,
  Icon,
  MenuItem,
  useColorStyle,
} from '@tonic-one/react';
import { HelpOIcon } from '@tonic-one/react-icons';
import { Popover } from 'antd';
import { useTranslation } from 'react-i18next';
import i18next from 'src/i18n';

import { CAS_DOC_LINK, getCasOLHLink } from '../../../utils/casDocLink';

const open = (
  url: string,
  target?: '_blank' | '_self' | '_parent' | '_top'
) => {
  target = target || '_blank';
  window.open(url, target);
};

function OnlineHelpMenu() {
  const { t } = useTranslation();
  const links = CAS_DOC_LINK.onlineHelpMenu;
  const openLink = (v: string) => () => {
    open(getCasOLHLink(v, i18next.language));
  };
  return (
    <>
      <MenuItem
        data-track="OLHP.whatCanIDoHere"
        onClick={openLink(links.whatCanIDoHere)}
      >
        {t('side.OLHP.whatCanIDoHere')}
      </MenuItem>

      <Divider orientation="horizontal" className={styles.menuLine} />

      {/* <MenuItem
        data-track="OLHP.controlDashboardData"
        onClick={openLink(links.controlDashboardData)}
      >
        {t('side.OLHP.controlDashboardData')}
      </MenuItem> */}
      <MenuItem
        data-track="OLHP.viewSummaryWidgets"
        onClick={openLink(links.viewSummaryWidgets)}
      >
        {t('side.OLHP.viewSummaryWidgets')}
      </MenuItem>
      <MenuItem
        data-track="OLHP.viewATPWidgets"
        onClick={openLink(links.viewATPWidgets)}
      >
        {t('side.OLHP.viewATPWidgets')}
      </MenuItem>
      <MenuItem
        data-track="OLHP.viewDLPWidgets"
        onClick={openLink(links.viewDLPWidgets)}
      >
        {t('side.OLHP.viewDLPWidgets')}
      </MenuItem>

      <Divider orientation="horizontal" className={styles.menuLine} />

      <MenuItem
        data-track="OLHP.aboutDashboard"
        onClick={openLink(links.aboutDashboard)}
      >
        {t('side.OLHP.aboutDashboard')}
      </MenuItem>
      <MenuItem
        data-track="OLHP.aboutWidgets"
        onClick={openLink(links.aboutWidgets)}
      >
        {t('side.OLHP.aboutWidgets')}
      </MenuItem>

      <Divider orientation="horizontal" className={styles.menuLine} />

      <MenuItem
        data-track="OLHP.provisionO365"
        onClick={openLink(links.provisionO365)}
      >
        {t('side.OLHP.provisionO365')}
      </MenuItem>
      <MenuItem
        data-track="OLHP.provisionMip"
        onClick={openLink(links.provisionMip)}
      >
        {t('side.OLHP.provisionMip')}
      </MenuItem>
      <MenuItem
        data-track="OLHP.provisionStorage"
        onClick={openLink(links.provisionStorage)}
      >
        {t('side.OLHP.provisionStorage')}
      </MenuItem>
      <MenuItem
        data-track="OLHP.addRmsAccount"
        onClick={openLink(links.addRmsAccount)}
      >
        {t('side.OLHP.addRmsAccount')}
      </MenuItem>
      {/* <MenuItem
        data-track="OLHP.provisionSalesforce"
        onClick={openLink(links.provisionSalesforce)}
      >
        {t('side.OLHP.provisionSalesforce')}
      </MenuItem> */}
      <MenuItem
        data-track="OLHP.provisionGmail"
        onClick={openLink(links.provisionGmail)}
      >
        {t('side.OLHP.provisionGmail')}
      </MenuItem>

      <Divider orientation="horizontal" className={styles.menuLine} />

      <MenuItem data-track="OLHP.whatsNew" onClick={openLink(links.whatsNew)}>
        {t('side.OLHP.whatsNew')}
      </MenuItem>
      <MenuItem
        data-track="OLHP.knownIssues"
        onClick={openLink(links.knownIssues)}
      >
        {t('side.OLHP.knownIssues')}
      </MenuItem>
      {/* <MenuItem onClick={notImplementedToast(toast)}>
            {t('side.OLHP.getStarted')}
          </MenuItem> */}
      <MenuItem data-track="OLHP.faq" onClick={openLink(links.faq)}>
        {t('side.OLHP.faq')}
      </MenuItem>
      <MenuItem
        data-track="OLHP.knowledgeBase"
        onClick={() =>
          open(
            i18next.language === 'ja'
              ? 'https://success.trendmicro.com/dcx/s/contactus?language=ja'
              : 'https://success.trendmicro.com/en-US/product/?name=cloud-app-security'
          )
        }
      >
        {t('side.OLHP.knowledgeBase')}
      </MenuItem>

      <Divider orientation="horizontal" className={styles.menuLine} />

      <MenuItem
        data-track="OLHP.PhishInsightCampaign"
        onClick={() => open(customConfig.ui.feature.phishInsight)}
      >
        {t('side.OLHP.phishInsight')}
      </MenuItem>

      <Divider orientation="horizontal" className={styles.menuLine} />
      {/* <MenuItem onClick={notImplementedToast(toast)}>
            {t('side.OLHP.phishInsight')}
          </MenuItem>

          <Divider orientation="horizontal" className={styles.menuLine} />*/}

      <MenuItem data-track="OLHP.about" onClick={openLink(links.about)}>
        {t('side.OLHP.about')}
      </MenuItem>
    </>
  );
}
export default function OnlineHelp({ collapsed }: { collapsed: boolean }) {
  const [colorStyle] = useColorStyle({ colorMode: 'dark' });
  const color = collapsed
    ? colorStyle.color.tertiary
    : colorStyle.color.emphasis;
  const size = collapsed ? '20px' : '14px';
  return (
    <Popover content={<OnlineHelpMenu />} trigger="click">
      <ButtonBase className="icon icon-btn" data-track="OLHP.open">
        <Icon as={HelpOIcon} color={color} size={size} />
      </ButtonBase>
    </Popover>
  );
}
